<template>
    <div style="width: 100%">
        <Breadcrumb></Breadcrumb>
        <div style="background-color: #FFFFFF;margin-top: 10px;border: 1px solid rgb(204, 204, 204);">
            <el-form ref="form" :model="form" label-width="80px" class="goods-pair-search-form">
                <el-form-item label="搜索类型 : ">
                    <el-radio-group v-model="form.type" size="medium" class="hide_input" @change="searchTypeChange">
                        <el-radio label="0">商品SKU</el-radio>
                        <el-radio label="1">商品编码</el-radio>
                        <el-radio label="2">商品名称</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="搜索内容 : ">
                    <el-input v-model.trim="form.content" :placeholder="placeholderContent"
                              style="width: 329px" size="small" onkeyup="this.value=this.value.replace(/，/ig,',')"></el-input>
                    <el-button type="primary" @click="loadData" style="margin-left: 15px" size="small">搜索</el-button>
                </el-form-item>
                <el-form-item label="排序类型 : ">
                    <el-radio-group v-model="form.sort" size="medium" class="hide_input sort-group">
                        <el-radio label="CREATE_TIME">按创建时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="UPDATE_TIME">按更新时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="WARE_NUM">按库存总量<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="COMM_PRICE">按单价<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="COMM_SKU">按SKU<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <!-- 表格操作栏 -->
        <div style="margin-top: 10px;text-align: right">
            <el-button type="primary" @click="importDialogVisible = true" size="small">导入</el-button>
        </div>
        <!-- 商品表格 -->
        <div class="goods-pair-table">
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="img" label="商品信息" width="350px" align="center">
                    <template slot-scope="scope">
                        <el-col :span="7">
                            <el-popover placement="right" width="300" trigger="hover" :disabled="scope.row.picUrl == null">
                                <img  class="img-big" :src="scope.row.picUrl" style="width: 300px;height: 300px"/>
                                <img v-if="scope.row.picUrl != null" slot="reference" class="img-small" :src="scope.row.picUrl" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                <img v-else slot="reference" class="img-small" src="../../../assets/images/kong.png" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                            </el-popover>
                        </el-col>
                        <el-col :span="7" style="margin-left: 5px;font-size: 13px">
                            <div style="width: 250px;text-align: left;margin-left: 5px"><span style="color: #a7a2a2">商品SKU:</span><span style="color: #428BAC">{{scope.row.commSku}}</span></div>
                            <div style="width: 250px;text-align: left;margin-left: 5px"><span style="color: #a7a2a2">中文名称:</span><span style="color: #428BAC">{{scope.row.chinName}}</span></div>
                            <div style="width: 250px;text-align: left;margin-left: 5px"><span style="color: #a7a2a2">商品编码:</span><span style="color: #428BAC">{{scope.row.commId}}</span></div>
                            <div style="width: 250px;text-align: left;margin-left: 5px"><span style="color: #a7a2a2">备注:</span><span style="color: #428BAC">{{scope.row.remarks}}</span></div>
                        </el-col>
                    </template>
                </el-table-column>
                <el-table-column prop="platSku" label="平台SKU" align="center">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.platSku">{{item}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="150">
                    <template slot-scope="scope">
                        <span>{{parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间" align="center" width="150">
                    <template slot-scope="scope">
                        <span>{{parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="editRow(scope.row)" icon="el-icon-edit">编辑</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <el-pagination background style="float: right;" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <!-- 导入弹出框 -->
        <el-dialog :close-on-click-modal="false"   title="导入商品" id="import" :visible.sync="importDialogVisible" width="30%">
            <!-- 上传控件 -->
            <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove" :file-list="importExcelFileList" :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-link type="primary" style="margin-left: 20px;">下载模版</el-link>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="12">
                        <div style="text-align: left;">
                            <span>
                                <font style="font-size: 14px;color: red;">注：一次最多导入5000行数据</font>
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-button @click="importDialogVisible = false" size="mini">取 消</el-button>
                        <el-button type="primary" @click="submitUpload" size="mini">确 定</el-button>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getGoodsList,updateRemark,deleteByCommIds,moveToStore} from "@/api/store/storeManage";
    export default {
        components:{Breadcrumb},
        name:'goodsPair',
        data: function () {
            return {
                total:0,
                form: {
                    type: '',
                    content: '',
                    sort: 'CREATE_TIME',
                    byAsc:'desc',//升序或者降序
                    currentPage: 1,
                    pageSize: 10
                },
                placeholderContent : '多个sku间用逗号隔开',
                tableData: [],
                // 导入
                importDialogVisible: false,
                importExcelFileList: [],

            };
        },
        created(){
            this.loadData();
        },
        methods: {
            //加载列表数据
            loadData(){
                getGoodsList(this.form).then(res =>{
                    if(res.code == 200){
                        this.tableData = res.rows;
                        this.tableData.forEach(row =>{
                            if(row.platSku != null){
                                row.platSku = row.platSku.split(',');
                            }
                        })
                        this.total = res.total;
                    }
                }).catch(err =>{});
            },
            searchTypeChange(val){
                if(val == '0'){
                    this.placeholderContent = '多个sku间用逗号隔开';
                }else if(val == '1'){
                    this.placeholderContent = '多个商品编码用逗号隔开';
                }else{
                    this.placeholderContent = null;
                }

            },
            turnWay(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'desc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'asc';
                }
                this.loadData();
            },
            handleSelectionChange(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.pageSize = val.length + " 条";
            },
            handleSizeChange(val) {
                this.form.pageSize = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.form.currentPage = val;
                this.loadData();
            },
            //导入上传控制
            submitUpload() {
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            //编辑
            editRow(row) {
                let data = {commId:row.commId,commSku:row.commSku,chinName:row.chinName}
                this.$router.push({path:'/repository/manage/pairEdit',query:{data:JSON.stringify(data)}})
            },
        }
    }
</script>

<style>
    /*去除按钮的左边框*/
    .searchType .el-radio-button:first-child .el-radio-button__inner {
        border-left: 0px solid #DCDFE6;
    }

    /*去除按钮的边框*/
    .searchType .el-radio-button__inner {
        border: 0px solid #DCDFE6;
    }
</style>
